import React from "react";

const CheckingEligibility = ({ isCheckingEligibilityOpen, customer }) => {
  if (!isCheckingEligibilityOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50 p-4 backdrop-blur-sm overflow-y-auto">
      {/* Kept original 670px width and proportional height structure */}
      <div className="bg-white rounded-md shadow-xl w-full max-w-[670px] min-h-[300px] my-auto p-6 sm:p-8 flex flex-col items-center justify-center text-center transition-all">
        {/* Animated Loading Dots */}
        <div className="flex space-x-3 mb-6 items-center justify-center shrink-0">
          <span
            className="w-2.5 h-2.5 sm:w-3 sm:h-3 bg-[#074073] rounded-full animate-bounce"
            style={{ animationDelay: "0s" }}
          ></span>
          <span
            className="w-2.5 h-2.5 sm:w-3 sm:h-3 bg-[#7FB8EB] rounded-full animate-bounce"
            style={{ animationDelay: "0.15s" }}
          ></span>
          <span
            className="w-2.5 h-2.5 sm:w-3 sm:h-3 bg-[#074073] rounded-full animate-bounce"
            style={{ animationDelay: "0.3s" }}
          ></span>
        </div>

        {/* Text Content - Safe wrapping without shrinking the modal */}
        <div className="text-center w-full px-2">
          <p className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 break-words">
            Checking Eligibility
          </p>
          <p className="text-gray-700 text-sm sm:text-base max-w-[500px] mx-auto leading-relaxed break-words">
            Checking borrower credentials and validating loan eligibility — this
            won’t take long...
          </p>
        </div>
      </div>
    </div>
  );
};

export default CheckingEligibility;
